import CardHeader from "@/components/Includes/CardHeader/CardHeader.vue";
import Loader from "@/components/Includes/Loader/Loader.vue";
import IClientApp from "@/interfaces/IClientApp";
import dateToStandart from "@/libs/date/dateToStandart";
import {Component, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";

import ClientAppCreate from '@/components/ClientApps/ClientAppCreate/ClientAppCreate.vue';
import ClientAppDetail from '@/components/ClientApps/ClientAppDetail/ClientAppDetail.vue';

import TableEmpty from '@/components/Includes/Table/TableFooter/TableEmpty/TableEmpty.vue';

import DefaultTools from '@/components/Includes/DefaultTools/DefaultTools.vue';
import Pagination from '@/components/Includes/Pagination/Pagination.vue';

import IPayloadQuery from "@/interfaces/IPayloadQuery";
import ITableCol from "@/interfaces/ITableCol";
import IMultiSelectItem from "@/interfaces/selects/IMultiSelectItem";

import IProfile from '@/interfaces/IProfile';
import cleanData from "@/libs/cleanData";
import getParamQuery from "@/libs/getParamQuery";
import getQueryData from "@/libs/getQueryData";
import getTableColumns from "@/libs/getTableColumns";
import searchByTable from "@/libs/searchQuery/searchByTable";
import urlToId from '@/libs/urlToId';
import { ROLE_MEDIA_BUYER } from '@/libs/userAbility/userAbilityRoles/defaultRoles';

const LIMIT = '100';

@Component({
    components: {
        CardHeader,
        Loader,
        ClientAppCreate,
        ClientAppDetail,
        TableEmpty,
        DefaultTools,
        Pagination
    }
})

export default class ClientApps extends Vue {
    @Action private clientAppsList!: (query: IPayloadQuery) => Promise<{data: IClientApp[], links: number}>;
    @Action private subscriptionsClientAppsList!: (query: IPayloadQuery) => Promise<{data: IClientApp[], links: number}>;
    @Getter private profile!: IProfile;


    private clientApps: IClientApp[] = [];
    private createClientAppForm: boolean = false;
    private detailClientAppForm: boolean = false;
    private selectedClientApp: IClientApp | null = null;

    private loading: boolean = false;

    private filtered: any = null;

    private selectedTableColumns: IMultiSelectItem[] = [];
    private selectedShowVpns: number | null = null;

    // Begin Config for Pagination
    private totalClientApps: number | void | null = null;
    private currentPage: number = 1;
    private selectedLimit: string = LIMIT;
    // End Config for Pagination


    // Begin Config for Table
    private showModalDetail(item: IClientApp) {
        this.detailClientAppForm = !this.detailClientAppForm;
        this.selectedClientApp = {
            id: item.id,
            title: item.title,
            email: item.email,
            isCampaignDriven: item.isCampaignDriven,
            vpnServers: item.vpnServers,
            autoCreateHosts: item.autoCreateHosts,
            domain: item.domain
        };
    }

    private hideModalDetail() {
        this.detailClientAppForm = false;
        this.selectedClientApp = null;
    }

    private filterData(query: string) { // Method for search tool
        this.filtered = searchByTable(query, this.clientApps)
    }


    private toggleVpns(item: any) {
        this.selectedShowVpns = this.selectedShowVpns !== item.id ? item.id : null;
    }

    private get tableItems(): IClientApp[] {
        return this.filtered ? this.formattedClientApps(this.filtered) : this.formattedClientApps(this.clientApps);
    }

    private get tableColumns(): ITableCol[] | undefined {
        if (this.tableItems) {
            return getTableColumns(this.clientApps, true, ['id']);
        }
    };

    private get fields() {
        if (this.tableColumns) {
            const columnsIds = this.selectedTableColumns.map((el: IMultiSelectItem) => el.value);
            return this.tableColumns.filter((el: any) => columnsIds.includes(el.key));
        } else {
            return this.tableColumns;
        }
    }

    private get isSubscriptions() {
        return this.$route.name === 'subscriptions_client_apps_list';
    }

    // End Config for Table

    private showModalCreate() {
        this.createClientAppForm = !this.createClientAppForm
    }

    private hideModalCreate() {
        this.createClientAppForm = false;
    }

    private formattedClientApps(data: IClientApp[]) {
        return data.map(el => {
            return {
                ...el,
                ...(el.createdAt && {createdAt: dateToStandart(el.createdAt)}),
                ...(el.updatedAt && {updatedAt: dateToStandart(el.updatedAt)}),
                // @ts-ignore
                ...(el.vpnServers && {vpnServers: el.vpnServers.map(vpnId => +urlToId(vpnId))})
            }

        })
    }

    // Begin Query Logic
    private get payloadQuery(): IPayloadQuery {
        return {
            ...getParamQuery(this.$route),
            metaData: true
        }
    }

    private get limitFromQuery(): string {
        const { limit = this.selectedLimit } =  this.$route.query;

        return typeof limit === 'string' ? limit : LIMIT;
    }

    private get pageFromQuery() {
        return +this.$route.query.page || 1;
    }

    private get isUserMediaBuyer() {
        return Array.isArray(this.profile.roles) && this.profile.roles.includes(ROLE_MEDIA_BUYER);
    }

    @Watch('selectedLimit')
    @Watch('currentPage')
    private writeQueryValue() {
        const queryData: any = {
            page: this.currentPage,
            limit: this.selectedLimit,
            pagination: true
        };

        this.$router.replace({
            name: this.$route.name || undefined,
            query: cleanData(queryData)
        });
    }

    // End Query Logic

    @Watch('selectedLimit')
    @Watch('currentPage')
    private async fetchClientAppsList() {
        if (this.loading) {
            return;
        }

        this.loading = true;

        try {
            this.writeQueryValue();
            const {links, data} = await this[this.isSubscriptions ? 'subscriptionsClientAppsList' : 'clientAppsList'](this.payloadQuery);
            this.totalClientApps = links;
            this.clientApps = data;
        } catch (error) {
            console.error(error);
        }

        this.loading = false;
    }

    private mounted() {
        this.fetchClientAppsList();
    }
}
